import React, { Component, useState, createRef } from "react";
import AuthBanner from "../icons/authBanner.svg";
import "../index.scss";

import InputField from "./inputField";
import CallIcon from "../icons/call.svg";
import ActionButton from "./actionButton";
import Sticker from "./sticker";
import BkashLogo from "../icons/bKash_Logo_button.svg";

export default function ExternalCampaignAuth({
  data,
  callBack,
  fetching,
  errorMessage,
}) {
  const [phone, setPhone] = useState("");
  const onChnagePhoneNumber = (e) => {
    setPhone(e.target.value);
  };
  return (
    <div className="campaign-auth-container">
      <img src={AuthBanner} className="banner-img" />
      <p className="auth-guide">আপনার বিকাশ মার্চেন্ট ওয়ালেট নম্বর দিন</p>
      <InputField
        value={phone}
        onChangeValue={onChnagePhoneNumber}
        icon={CallIcon}
      />

      <ActionButton
        title="এগিয়ে যান"
        disabled={phone.length === 10 ? false : true}
        onClick={() => callBack(phone)}
        loading={fetching}
        leftIconSrc={BkashLogo}
      />

      {errorMessage && <p className="error-text">{errorMessage}</p>}

      <p className="bonus-text">{data.guide}</p>

      {data?.max_payout_amount !== "" && (
        <Sticker
          title={data?.max_payout_amount}
          subTitle="টাকা পর্যন্ত বোনাস!"
        />
      )}
    </div>
  );
}
